// Le canal des médailles fraîchement gravées : n'importe quel écran qui en
// reçoit les annonce ici, le bandeau (components/MedalToaster.js) écoute.
export function announceMedals(medals) {
  if (!Array.isArray(medals) || !medals.length) return;
  window.dispatchEvent(new CustomEvent("pq:medals", { detail: medals }));
}

// Ouvre la fiche d'une médaille (components/MedalPopup.js) : au clic, pas au
// survol, pour que ça marche aussi au doigt. `action` : un bouton en plus,
// { label, onClick } — épingler depuis la grille du profil, par exemple.
export function showMedal(medal, action = null) {
  if (!medal) return;
  window.dispatchEvent(new CustomEvent("pq:medal-show", { detail: { medal, action } }));
}
